export default __webpack_public_path__ + "static/media/WM0490.34I-43619_-26038_15.271deb84.jpg";